import {take, put, select} from 'redux-saga/effects';
import {ROUTE_UNMOUNT_SIDE_EFFECT_COMPLETED} from '@computerrock/formation-router';
import {efServiceAssignmentTypes} from '@ace-de/eua-entity-types';
import updateServiceCase from '../../service-cases/sagas/updateServiceCase';
import updateServiceAssignment from '../../service-assignments/sagas/updateServiceAssignment';
import * as samcActionTypes from '../samcActionTypes';
import modalIds from '../../modalIds';

/**
 * Update SAMC journey details
 */
const updateSAMCJourneyDetails = function* updateSAMCJourneyDetails() {
    while (true) {
        const {payload} = yield take(samcActionTypes.SUBMIT_SAMC_JOURNEY_DETAILS_FORM);
        const {location} = yield select(state => state.router);
        // do not PATCH journey data when modal is open,
        // neither confirm vehicle selection modal nor vehicle data modal
        if (location?.state?.isModalOpen
            && [modalIds.CONFIRM_VEHICLE_SELECTION, modalIds.VEHICLE_DATA].includes(location?.state?.modalId)
        ) {
            continue;
        }

        const {serviceCaseData, serviceCaseId, serviceAssignmentLineNo, serviceAssignmentData, caseType} = payload;

        yield* updateServiceAssignment({
            caller: samcActionTypes.SUBMIT_SAMC_JOURNEY_DETAILS_FORM,
            assignmentType: efServiceAssignmentTypes.MEDICAL_CLEARANCE,
            serviceAssignmentLineNo,
            serviceCaseId,
            serviceAssignmentData,
        });

        yield* updateServiceCase({
            caller: samcActionTypes.SUBMIT_SAMC_JOURNEY_DETAILS_FORM,
            caseType: caseType,
            serviceCaseId,
            serviceCaseData,
        });

        yield put({
            type: ROUTE_UNMOUNT_SIDE_EFFECT_COMPLETED,
            payload: {caller: samcActionTypes.SUBMIT_SAMC_JOURNEY_DETAILS_FORM},
        });
    }
};

export default updateSAMCJourneyDetails;
